module.exports = __webpack_public_path__ + "static/img/30011 (3).06dd5b4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30011 (3).webp
// module id = ZXru
// module chunks = 14